var map = {
	"./de/btn-back.png": "4KxV",
	"./en/btn-back.png": "gubr",
	"./es/btn-back.png": "oLrM",
	"./fr/btn-back.png": "r9gX",
	"./ja/btn-back.png": "+M4c",
	"./ko/btn-back.png": "NV2a",
	"./pt/btn-back.png": "l741",
	"./ru/btn-back.png": "0Ujn",
	"./th/btn-back.png": "Gl6H",
	"./zh-Hant/btn-back.png": "ipzG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VV8T";